module.exports = __webpack_public_path__ + "img/facebook.82d7da83.svg";